import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { clearStorage, getLangByCountry, isSourceFordPass } from '@agenda-customer-ui/shared';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ButtonLibComponent } from '@components/atoms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '@core/envs';
import { ParamsPath } from '@core/enums';

@Component({
  selector: 'agenda-customer-ui-logout-remote',
  standalone: true,
  imports: [CommonModule, ButtonLibComponent, TranslateModule],
  templateUrl: './logout-remote-component.component.html',
  styleUrls: ['./logout-remote-component.component.scss'],
  providers: [TranslateService]
})
export class LogoutRemoteComponent implements OnInit {
  country?: string
  source?: string
  isFordPass = false;
  openedModal = false;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    const params = await firstValueFrom(this.route.params);
    this.country = params[ParamsPath.COUNTRY];
    this.source = params[ParamsPath.SOURCE];

    this.#getLang(this.country ?? '');

    this.isFordPass = isSourceFordPass(this.source ?? '');
    this.openedModal = !this.isFordPass;

    if (this.isFordPass) {
      this.#showFordPassTemplate();
    }
  }

  doLogout = (): void => {
    clearStorage();
    const param = this.country ? `?${ParamsPath.COUNTRY_FMA}=${this.country}` : '';
    window.open(`${environment.project.shell}logout${param}`, '_self')?.focus();
  }

  #showFordPassTemplate = (): void => {
    clearStorage();
  }

  #getLang(country: string) {
    const language = sessionStorage.getItem('tempLang') ?? getLangByCountry(country);

    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }

}
